import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';
import { HomePageComponent } from './home/home-page/home-page.component';
import { LandingComponent } from './home/landing/landing.component';
import { ProgramsPageComponent } from './home/programs-page/programs-page.component';
import { PlatinumPageComponent } from './home/platinum-page/platinum-page.component';
import { FooterComponent } from './home/footer/footer.component';
import { AboutusComponent } from './home/about-us/about-us.component';
import { BillingPageComponent } from './billing-page/billing-page.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { GoldPageComponent } from './home/gold-page/gold-page.component';
import { LivSessionpageComponent } from './home/liv-sessionpage/liv-sessionpage.component';
import { InstructorsComponent } from './home/instructors/instructors.component';
import { SalesLeadershipCertificatesComponent } from './home/sales-leadership-certificates/sales-leadership-certificates.component';
import { TermAndConditionsComponent } from './home/term-and-conditions/term-and-conditions.component';
import { BusinessBuilderComponent } from './home/business-builder/business-builder.component';
import { BlogsComponent } from './home/blogs/blogs.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { CodeConfirmationComponent } from './code-confirmation/code-confirmation.component';
import { AuthGuard } from './guards/auth.guard';
import { AlreadyLoggedInGuard } from './guards/already-logged-in.guard';
import { VerifySessionComponent } from './verify-session/verify-session.component';
import { InstructorViewerComponent } from './home/instructor-viewer/instructor-viewer.component';
import { GoldBrochureComponent } from './home/gold-brochure/gold-brochure.component';
import { PlatinumBrochureComponent } from './home/platinum-brochure/platinum-brochure.component';
import { DevLoginComponent } from './dev-login/dev-login.component';
import { DevGateGuard } from './shared/dev-gate.guard';
import { AdminInstuctorLoginComponent } from './admin-instructor-login/admin-instructor.login.component';
import { CommunityComponent } from './home/community/community.component';
import { CommunitySessionSuccessComponent } from './home/community/community-session-verify/community-session-success.component';
import { IcfOverviewComponent } from './home/icf-overview/icf-overview.component';
import { FaqComponent } from './home/faq/faq.component';
import { HelpCenterComponent } from './home/help-center/help-center.component';

const routes: Routes = [
  // { path: 'dev-login', component: DevLoginComponent },
  //  {
  //   path: '',
  //   canActivate: [DevGateGuard],
  //   children: [
      
  
  // // { path: 'installments', component: InstallmentComponent },
  //  ]},
  //  { path: '**', redirectTo: '' },
   {
  path: 'admin',
  loadChildren: () =>
    import('./admin/admin.module').then((m) => m.AdminModule),
  canActivate: [AuthGuard],
  data: { role: 'admin' },
},
{
  path: 'instructor',
  loadChildren: () =>
    import('./instructor/instructor.module').then((m) => m.InstructorModule),
  canActivate: [AuthGuard],
  data: { role: 'instructor' },
},
{
  path: 'student',
  loadChildren: () =>
    import('./student/student.module').then((m) => m.StudentModule),
  canActivate: [AuthGuard],
  data: { role: 'student' },
},

  { path: '', redirectTo: '/login', pathMatch: 'full' },
  // { path: 'home', component: HomePageComponent },
  // { path: 'about-us', component: AboutusComponent },
  // {
  //   path: 'leadership-certificates',
  //   component: SalesLeadershipCertificatesComponent,
  // },
  // { path: 'terms-and-conditions', component: TermAndConditionsComponent },
  // { path: 'business-builder', component: BusinessBuilderComponent },
  // { path: 'blogs', component: BlogsComponent },
  { path: 'live-session', component: LivSessionpageComponent },
  // { path: 'program-page', component: ProgramsPageComponent },
  // { path: 'platinum-package', component: PlatinumPageComponent },
  // { path: 'gold-package', component: GoldPageComponent },
  { path: 'billing-form', component: BillingPageComponent },
  // { path: 'landing-page', component: LandingComponent },
  // { path: 'our-team', component: InstructorsComponent },
  // { path: 'instructor-viewer', component: InstructorViewerComponent },
  // { path: 'signup', component: SignupComponent },
  { path: 'login', component: LoginComponent, canActivate: [AlreadyLoggedInGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'confirm-code', component: CodeConfirmationComponent },
  { path: 'verify-session', component: VerifySessionComponent },
  { path: 'admin-instructor-login', component: AdminInstuctorLoginComponent },
  { path: 'community', component: CommunityComponent },
  { path: 'community-session-success', component: CommunitySessionSuccessComponent },
  { path: 'icf-overview', component: IcfOverviewComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'help-center', component: HelpCenterComponent },

  // { path: 'footer', component: FooterComponent },
  // {
  // path: 'gold-brochure',
  // component: GoldBrochureComponent
  // },
  // {
  // path: 'platinum-brochure',
  // component: PlatinumBrochureComponent
  // },
  
];

@NgModule({
  imports: [
   RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'disabled', // disable Angular’s auto scroll
  anchorScrolling: 'disabled',
  onSameUrlNavigation: 'reload'
})
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}






// import { NgModule } from '@angular/core';
// import { RouterModule, Routes } from '@angular/router';

// import { DevGateGuard } from './shared/dev-gate.guard';

// import { HomePageComponent } from './home/home-page/home-page.component';
// import { LandingComponent } from './home/landing/landing.component';
// import { ProgramsPageComponent } from './home/programs-page/programs-page.component';
// import { PlatinumPageComponent } from './home/platinum-page/platinum-page.component';
// import { FooterComponent } from './home/footer/footer.component';
// import { AboutusComponent } from './home/about-us/about-us.component';
// import { BillingPageComponent } from './billing-page/billing-page.component';
// import { LoginComponent } from './login/login.component';
// import { SignupComponent } from './signup/signup.component';
// import { GoldPageComponent } from './home/gold-page/gold-page.component';
// import { LivSessionpageComponent } from './home/liv-sessionpage/liv-sessionpage.component';
// import { InstructorsComponent } from './home/instructors/instructors.component';
// import { SalesLeadershipCertificatesComponent } from './home/sales-leadership-certificates/sales-leadership-certificates.component';
// import { TermAndConditionsComponent } from './home/term-and-conditions/term-and-conditions.component';
// import { BusinessBuilderComponent } from './home/business-builder/business-builder.component';
// import { BlogsComponent } from './home/blogs/blogs.component';
// import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
// import { CodeConfirmationComponent } from './code-confirmation/code-confirmation.component';
// import { VerifySessionComponent } from './verify-session/verify-session.component';
// import { InstructorViewerComponent } from './home/instructor-viewer/instructor-viewer.component';
// import { GoldBrochureComponent } from './home/gold-brochure/gold-brochure.component';
// import { PlatinumBrochureComponent } from './home/platinum-brochure/platinum-brochure.component';


// import { InsightsComponent } from './admin/insights/insights.component';
// import { LibraryComponent } from './admin/library/library.component';
// import { CertificatesComponent } from './admin/certificates/certificates.component';
// import { QuizesComponent } from './admin/quizes/quizes.component';
// import { AssignmentsComponent } from './admin/assignments/assignments.component';

// import { EmailSettingsComponent } from './admin/site-management/email-settings/email-settings.component';

// import { StudentsComponent } from './admin/manage-users/students/students.component';

// import { SubscriptionListComponent } from './admin/manage-subscriptions/subscription-list/subscription-list.component';
// import { PurchasedSubscriptionComponent } from './admin/manage-subscriptions/purchased-subscription/purchased-subscription.component';

// import { HelpComponent } from './admin/help/help.component';
// import { HelpDetailsComponent } from './admin/help-details/help-details.component';

// import { PaymentMethodsComponent } from './admin/transactions-payments/payment-methods/payment-methods.component';
// import { PaymentsComponent } from './admin/transactions-payments/payments/payments.component';

// import { AllBlogsComponent } from './admin/manage-blogs/all-blogs/all-blogs.component';
// import { CategoriesComponent } from './admin/manage-blogs/categories/categories.component';

// import { IdentityVerificationComponent } from './admin/identity-verification/identity-verification.component';

// import { CommunityComponent } from './admin/community/community.component';
// import { CategoryComponent } from './admin/community/category/category.component';
// import { ForumCategoryComponent } from './admin/community/forum-category/forum-category.component';

// import { BadgesComponent } from './admin/badges/badges.component';

// import { AllCoursesComponent } from './admin/manage-courses/all-courses/all-courses.component';
// import { CourseCategoryComponent } from './admin/manage-courses/course-category/course-category.component';

// import { BookingsComponent } from './admin/bookings/bookings.component';
// import { LiveSessionsComponent } from './admin/live-sessions/live-sessions.component';
// import { VideosComponent } from './admin/videos/videos.component';

// const routes: Routes = [
//   // ✅ dev login NOT guarded
//   {
//     path: 'dev-login',
//     loadComponent: () =>
//       import('./dev-login/dev-login.component').then((m) => m.DevLoginComponent),
//   },

//   // ✅ everything else guarded here (including lazy modules + deep routes)
//   {
//     path: '',
//     canMatch: [DevGateGuard],
//     children: [
//       {
//         path: 'admin',
//         loadChildren: () =>
//           import('./admin/admin.module').then((m) => m.AdminModule),
//         data: { role: 'admin' },
//       },
//       {
//         path: 'instructor',
//         loadChildren: () =>
//           import('./instructor/instructor.module').then((m) => m.InstructorModule),
//         data: { role: 'instructor' },
//       },
//       {
//         path: 'student',
//         loadChildren: () =>
//           import('./student/student.module').then((m) => m.StudentModule),
//         data: { role: 'student' },
//       },

//       { path: '', redirectTo: 'home', pathMatch: 'full' },
//       { path: 'home', component: HomePageComponent },
//       { path: 'about-us', component: AboutusComponent },
//       { path: 'leadership-certificates', component: SalesLeadershipCertificatesComponent },
//       { path: 'terms-and-conditions', component: TermAndConditionsComponent },
//       { path: 'business-builder', component: BusinessBuilderComponent },
//       { path: 'blogs', component: BlogsComponent },
//       { path: 'live-session', component: LivSessionpageComponent },
//       { path: 'program-page', component: ProgramsPageComponent },
//       { path: 'platinum-package', component: PlatinumPageComponent },
//       { path: 'gold-package', component: GoldPageComponent },
//       { path: 'billing-form', component: BillingPageComponent },
//       { path: 'landing-page', component: LandingComponent },
//       { path: 'our-team', component: InstructorsComponent },
//       { path: 'instructor-viewer', component: InstructorViewerComponent },
//       { path: 'signup', component: SignupComponent },
//       { path: 'login', component: LoginComponent },
//       { path: 'forgot-password', component: ForgotPasswordComponent },
//       { path: 'confirm-code', component: CodeConfirmationComponent },
//       { path: 'verify-session', component: VerifySessionComponent },
//       { path: 'footer', component: FooterComponent },
//       { path: 'gold-brochure', component: GoldBrochureComponent },
//       { path: 'platinum-brochure', component: PlatinumBrochureComponent },
//       { path: 'transactions/payment', redirectTo: 'transactions-payments/payments', pathMatch: 'full' },

//       // Old: /admin/transactions/payment-methods
//       // New: /admin/transactions-payments/payment-methods
//       { path: 'transactions/payment-methods', redirectTo: 'transactions-payments/payment-methods', pathMatch: 'full' },

//       // ✅ Existing routes
//       { path: 'dashboard', component: InsightsComponent },
//       { path: 'library', component: LibraryComponent },
//       { path: 'certificates', component: CertificatesComponent },
//       { path: 'quizes', component: QuizesComponent },
//       { path: 'assignments', component: AssignmentsComponent },

//       { path: 'site-management/email-settings', component: EmailSettingsComponent },

//       { path: 'manage-users/student', component: StudentsComponent },
//       { path: 'manage-users/instructors', component: InstructorsComponent },

//       { path: 'manage-subscriptions/subscription-list', component: SubscriptionListComponent },
//       { path: 'manage-subscriptions/purchased-subscription', component: PurchasedSubscriptionComponent },

//       { path: 'help', component: HelpComponent },
//       { path: 'help-detail/:id', component: HelpDetailsComponent },

//       { path: 'transactions-payments/payment-methods', component: PaymentMethodsComponent },
//       { path: 'transactions-payments/payments', component: PaymentsComponent },

//       { path: 'manage-blogs/all-blogs', component: AllBlogsComponent },
//       { path: 'manage-blogs/categories', component: CategoriesComponent },

//       { path: 'identity-verification', component: IdentityVerificationComponent },

//       { path: 'community/communities', component: CommunityComponent },
//       { path: 'community/categories', component: CategoryComponent },
//       { path: 'forum/:forumId', component: ForumCategoryComponent },

//       { path: 'badges', component: BadgesComponent },

//       { path: 'manage-courses/all-courses', component: AllCoursesComponent },
//       { path: 'manage-courses/course-category', component: CourseCategoryComponent },

//       { path: 'bookings', component: BookingsComponent },
//       { path: 'live-sessions', component: LiveSessionsComponent },
//       { path: 'videos', component: VideosComponent },

//       // ✅ Default inside admin
//       { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
//     ],
//   },
// ];

// @NgModule({
//   imports: [
//     RouterModule.forRoot(routes, {
//       scrollPositionRestoration: 'disabled',
//       anchorScrolling: 'disabled',
//       onSameUrlNavigation: 'reload',
//     }),
//   ],
//   exports: [RouterModule],
// })
// export class AppRoutingModule {}
